function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { checkIsTizenVersion, ChromecastModel, DeviceType, isModelPremium, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { sdkLogger } from '../../logger';
var logger = sdkLogger.withContext('PeacockPropositionLoader');
export var PREROLL_WHITELISTED_VIZIO_MODELS = [
    'P75Q9-J01',
    'P65Q9-J01',
    'P75Q9-H1',
    'P85QX-H1',
    'OLED55-H1',
    'P65Q9-H1',
    'OLED65-H1',
    'P75QX-H1',
    'P65QX-H1'
];
function loadWebMafSlePreroll(_, deviceType) {
    logger.warn("Setting Sle Pre Roll for ".concat(deviceType, " device to false, since it is not supported on this platform"));
    return false;
}
function loadTizenSlePreroll(deviceInfo, deviceType) {
    var model = deviceInfo.deviceModel;
    var whiteListedModels = [
        'QBQ6D',
        'QBQ60'
    ];
    var isSupportedTizen = !checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.4']) && !checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-2.3']);
    if (whiteListedModels.includes(model) || isModelPremium(deviceInfo) && isSupportedTizen) {
        return true;
    } else {
        logger.warn("Setting SLE Preroll for non-premium ".concat(deviceType, " device to false"));
        return false;
    }
}
function loadChromecastSlePreroll(deviceInfo, _) {
    var whiteListedModels = [
        ChromecastModel.ULTRA,
        ChromecastModel.ANDROID_TV,
        ChromecastModel.NEST_HUB,
        ChromecastModel.NEST_HUB_MAX
    ];
    if (whiteListedModels.includes(deviceInfo.deviceModel)) {
        return true;
    }
    sdkLogger.warn("Setting SLE Preroll for Chromecast model ".concat(deviceInfo.deviceModel, " to false"));
    return false;
}
function loadWebOsSlePreroll(deviceInfo, deviceType) {
    // https://jira.inbcu.com/browse/PBSCVJS-395
    var lgDeviceModelWhitelist = [
        'OLED65C2PUA',
        'OLED77G1PUA',
        'OLED55C1AUB',
        'OLED77C1PUB',
        'OLED55C1PUB',
        'OLED65C1AUB',
        'OLED65C1PUB',
        'OLED48C1PUB',
        'OLED65G1PUA',
        'OLED77C1AUB',
        'OLED48C1AUB',
        'OLED55G1PUA'
    ];
    var webOSSlePreRollSupport = lgDeviceModelWhitelist.includes(deviceInfo.deviceModel);
    logger.warn("Setting Sle Pre Roll for device ".concat(deviceType, " device model ").concat(deviceInfo.deviceModel, " device to ").concat(webOSSlePreRollSupport));
    return webOSSlePreRollSupport;
}
function loadVizioSlePreroll(_, deviceType) {
    var VIZIO = self.VIZIO;
    var vizioModel = VIZIO.deviceModel;
    if (PREROLL_WHITELISTED_VIZIO_MODELS.includes(vizioModel)) {
        return true;
    }
    logger.warn("Setting SLE Preroll for non-premium ".concat(deviceType, " device to false"));
    return false;
}
export function getSlePrerollSupport(deviceInfo, deviceType) {
    var _obj;
    var slePrerollMapping = (_obj = {}, _define_property(_obj, DeviceType.Tizen, loadTizenSlePreroll), _define_property(_obj, DeviceType.Chromecast, loadChromecastSlePreroll), _define_property(_obj, DeviceType.WebMaf, loadWebMafSlePreroll), _define_property(_obj, DeviceType.WebOS, loadWebOsSlePreroll), _define_property(_obj, DeviceType.Vizio, loadVizioSlePreroll), _obj);
    var slePrerollLoader = slePrerollMapping[deviceType];
    if (slePrerollLoader) {
        return slePrerollLoader(deviceInfo, deviceType);
    }
    return true;
}

//# sourceMappingURL=playback-capabilities.js.map